import { useState, useEffect, useRef } from "react";
import bidService from "./bidService";

export default function usePrebidBidding(adUnitId) {
  const [bidData, setBidData] = useState({
    winningAd: null,
    bidder: null,
    cpm: null,
    nurl: null,
    isVideo: false,
    ad_id: null,
    width: null,
    height: null,
  });

  const isMountedRef = useRef(false);

  useEffect(() => {
    if (!adUnitId) return;

    isMountedRef.current = true;

    const handleBidUpdate = (data) => {
      if (!isMountedRef.current) return;

      // data may be undefined/null in some flows; guard
      const next = {
        winningAd: data?.winningAd ?? null,
        bidder: data?.bidder ?? null,
        cpm: data?.cpm ?? null,
        nurl: data?.nurl ?? null,
        isVideo: data?.isVideo ?? false,
        ad_id: data?.ad_id ?? null,
        width: data?.width ?? null,
        height: data?.height ?? null,
      };

      setBidData((prev) => {
        // Use stable identifiers (ad_id, nurl, cpm) to decide if we actually changed
        if (
          prev.ad_id === next.ad_id &&
          prev.nurl === next.nurl &&
          prev.cpm === next.cpm &&
          prev.bidder === next.bidder &&
          prev.isVideo === next.isVideo &&
          prev.width === next.width &&
          prev.height === next.height
        ) {
          // nothing meaningful changed — keep previous object (avoid re-render)
          return prev;
        }
        return next;
      });
    };

    const unsubscribe = bidService.subscribe(adUnitId, handleBidUpdate);

    return () => {
      isMountedRef.current = false;
      try {
        unsubscribe && unsubscribe();
      } catch (e) {}
    };
  }, [adUnitId]);

  return bidData;
}
